import React from "react";
import { TextMd, TextSm } from "../../../components/text";
import { useAppContext } from "../../../context/appContext";
import { SeeMore } from "../components/seeMore";

export const ProcessAutomationSection = ({ className = "", style = {} }) => {
  const { routing } = useAppContext();
  const { navigate } = routing;

  return (
    <button
      className={`w-full flex flex-col items-center gap-8 text-left ${className}`}
      style={style}
      onClick={() => {
        navigate("/process-automation");
      }}
    >
      <div className="w-full flex flex-col">
        <TextSm className="uppercase whitespace-nowrap tracking-[0.1em] text-blue-500 font-semibold">
          Process Automation
        </TextSm>

        <TextMd className="font-semibold text-slate-900 mb-4">
          Streamlining repetitive work into reliable automated systems.
        </TextMd>

        <TextSm className="text-slate-500 leading-7 mb-8">
          Automation solutions built to reduce manual tasks, connect business
          tools, eliminate bottlenecks, and create repeatable workflows that
          save time while improving accuracy.
        </TextSm>

        <div className="flex flex-wrap gap-x-8 gap-y-3">
          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Workflow Automation</TextSm>
          </div>

          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>System Integrations</TextSm>
          </div>

          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Operational Efficiency</TextSm>
          </div>
        </div>
      </div>

      <SeeMore />
    </button>
  );
};